export const LOCAL_VERSION = "9.0.0"



// WEBPACK FOOTER //
// ./src/local_version.js